import Vue from 'vue';
import VueCookies from 'vue-cookies';
import axios from "axios";
import environment from "@/assets/js/environment";
import Qs from 'qs';
Vue.prototype.$http = axios;
var paramsSerializer = function paramsSerializer(params) {
  return Qs.stringify(params, {
    arrayFormat: 'repeat'
  });
};
var API_CORE = axios.create({
  baseURL: environment.apiUrl,
  paramsSerializer: paramsSerializer
});
var API_EMPRESA = axios.create({
  paramsSerializer: paramsSerializer
});
var API_VALIDATOR = axios.create({
  baseURL: environment.apiValidatorUrl
});
var token = VueCookies.get('meLembreToken');
if (token) {
  API_CORE.defaults.headers.common['Authentication-Token'] = token;
  API_EMPRESA.defaults.headers.common['Authentication-Token'] = token;
}
export default {
  generic: axios,
  apiCore: API_CORE,
  apiEmpresa: API_EMPRESA,
  apiValidator: API_VALIDATOR
};